import { Component } from '@angular/core';
import { ToastComponent } from '../toast.component';

@Component({
  selector: 'io-provetech-error-toast',
  templateUrl: './error-toast.component.html',
})
export class ErrorToastComponent extends ToastComponent {}
